import { Alert, CircularProgress, Modal, Snackbar, Box } from "@mui/material";
import { useState } from "react";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import servConsultaAcesso from "../../../services/login/servConsultaAcesso";
import { style as modalStyle } from "../../../components/Loading/Loading";
import "../style.css";

const SolicitacaoAnalise = ({ setOpenPopup, recordForEdit, pesquisar }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [openErrorWindow, setOpenErrorWindow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [severity, setSeverity] = useState("success");

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenErrorWindow(false);
        }

        setOpenErrorWindow(false);
    }

    const solicitarAnalise = async () => {
        if (recordForEdit === null) {
            return;
        }

        try {

            setIsLoading(true);

            const response = await servConsultaAcesso.EnviarParaAnalise(recordForEdit.id);

            setIsLoading(false);

            setSeverity("success");
            setErrorMessage("Orçamento estimado enviado para análise com sucesso.");
            setOpenErrorWindow(true);

            setTimeout(() => {
            
                setOpenPopup(false);
            }, 2000);

            pesquisar();

        } catch (err) {
            setIsLoading(false);
            setSeverity("error");
            setErrorMessage(err.response.data.Message);
            return setOpenErrorWindow(true);
        }
    }
    
    return (
        <div style={{ width: "100%", height: "200px" }}>
            <h4>
                Você deseja enviar o orçamento estimado para análise? <br />
                Após o envio, o orçamento não poderá ser alterado, para isso, será necessário criar uma nova consulta. 
            </h4>
            <div className="homologacao_consulta">
                <BlueHoverButton onClick={() => setOpenPopup(false)}>Cancelar</BlueHoverButton>
                <BlueHoverButton onClick={solicitarAnalise}>Enviar</BlueHoverButton>
            </div>

            <Snackbar open={openErrorWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError}> 
                    <Alert onClose={handleCloseError} severity={severity} sx={{ width: '100%' }}>
                        {errorMessage}
                    </Alert>
            </Snackbar>

            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
        </div>
    );
}

export {SolicitacaoAnalise };